export interface LoyaltyHeroBannerThemeInterface {
  smallImageUrl: string
  largeImageUrl: string
  alternateImageUrl?: {
    smallImageUrl?: string
    largeImageUrl?: string
    aspectRatioDesktop?: string
    aspectRatioMobile?: string
  }
}

export const theme: LoyaltyHeroBannerThemeInterface = {
  smallImageUrl:
    'https://s1.thcdn.com/design-assets/whitelabel/components/heroBanner/loyaltyImageSmall.jpg',
  largeImageUrl:
    'https://s1.thcdn.com/design-assets/whitelabel/components/heroBanner/loyaltyImageLarge.jpg',
}
